export default function CreatineBenefits() {
  return (
    <section className="bg-base-100 py-24 px-6 flex flex-col items-center gap-40">
      <div className="flex flex-col gap-10 md:gap-20 max-w-6xl w-full">
        <div className="flex flex-col gap-6">
          <h2 className="text-4xl md:text-5xl font-semibold font-grotesk text-center">
            More than an app, we're a network
          </h2>
          <p className="text-xl text-center font-grotesk">
            {" "}
            We are building a way to connect, share and engage with data
            meaningfully.
          </p>
        </div>
        <div className="flex flex-col gap-10 md:grid md:grid-cols-3 md:gap-20 w-full text-center">
          <div className="flex flex-col gap-4 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-12 h-12 text-base-content/60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
              />
            </svg>
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-semibold">Find your community</h3>
              <p className=" font-grotesk">
                Connect with like-minded athletes, share your achievements, and
                get inspired by the global PEAK community. Train together,
                celebrate victories, and push each other to reach new heights.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-12 h-12 text-base-content/60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-semibold">Control your data</h3>
              <p className="font-grotesk">
                Your training data belongs to you. Analyze, or delete your
                information anytime. We are building tools to give you complete
                ownership and transparency over your athletic journey.
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-4 items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-12 h-12 text-base-content/60"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
              />
            </svg>
            <div className="flex flex-col gap-2">
              <h3 className="text-lg font-semibold">Securely built</h3>
              <p className="font-grotesk">
                Built with privacy-first architecture and industry-leading
                security protocols to keep your performance insights and
                training data safe, secure and private at all times.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
